var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgramImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 317,
    viewBox: "0 0 353 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_156)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M261.137 317.112L115.555 233.013L177.43 197.466L322.993 281.565L261.137 317.112Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.647 82.5391L115.898 232.495L261.501 317.111L292.25 166.08L146.647 82.5391Z",
    fill: "#D7DFF6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M261.66 303.151L287.712 168.131L149.473 88.832L123.242 223.752L261.66 303.151Z",
    fill: "#03336E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.547 301.478L287.713 168.131L149.474 88.832L122.148 222.08L260.547 301.478Z",
    fill: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M258.312 302.932L287.707 168.131L149.468 88.832L119.914 223.533L258.312 302.932Z",
    fill: "#03336E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.695 300.861L287.707 168.131L149.468 88.832L119.297 221.442L257.695 300.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.038 228.513L241.257 244.644L224.539 234.905L228.261 218.814L245.038 228.513Z",
    fill: "url(#paint0_linear_2_156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.461 151.403L196.181 181.633L199.923 165.263L147.521 135.133L143.461 151.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.461 151.403L196.181 181.633L199.923 165.263L147.521 135.133L143.461 151.403Z",
    fill: "url(#paint1_linear_2_156)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.703 267.842L252.009 287.856L255.771 271.487L220.763 251.572L216.703 267.842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.703 267.842L252.009 287.856L255.771 271.487L220.763 251.572L216.703 267.842Z",
    fill: "url(#paint2_linear_2_156)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.74 289.549L127.656 217.798L146.444 133.46L271.368 205.132L252.74 289.549ZM129.925 216.782L251.387 286.463L269.119 206.108L147.797 136.507L129.925 216.782Z",
    fill: "#A8CFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.473 205.272L251.352 287.675L253.295 288.103L271.417 205.7L269.473 205.272Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.391 277.941L236.346 265.813L252.208 195.256L251.253 207.364L235.391 277.941Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.508 267.762L221.349 243.944L234.902 185.217L231.041 209.034L217.508 267.762Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.609 257.607L206.356 222.079L217.581 175.181L210.834 210.708L199.609 257.607Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.719 247.45L191.371 200.232L200.267 165.163L190.635 212.38L181.719 247.45Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.828 237.273L176.386 178.366L182.974 155.126L170.416 214.053L163.828 237.273Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.961 227.117L161.385 156.5L165.664 145.109L150.22 215.706L145.961 227.117Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.108 134.75L127.844 217.08L129.787 217.512L148.051 135.181L146.108 134.75Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.279 216.424L128.289 218.151L251.561 288.876L252.551 287.149L129.279 216.424Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.821 258.146L132.406 201.23L157.821 213.976L256.236 270.891L230.821 258.146Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.843 227.537L136.266 184.422L186.12 211.625L259.678 254.76L209.843 227.537Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.849 196.928L140.148 167.614L214.403 209.295L263.123 238.629L188.849 196.928Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87 166.32L144.008 150.807L242.702 206.965L266.564 222.479L167.87 166.32Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.615 134.124L146.625 135.852L269.741 206.487L270.731 204.76L147.615 134.124Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.241 166.08L261.492 317.111L292.281 290.446L322.989 281.564L292.241 166.08Z",
    fill: "#F7F6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.546 281.703L323.004 281.564L292.256 166.08L274.344 254.042L322.546 281.703Z",
    fill: "#E8EDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.762 290.307L269.636 277.044L261.477 317.112L292.285 290.446L292.762 290.307Z",
    fill: "#E8EDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.241 166.08L261.492 317.111L292.281 290.466L323.009 281.584L292.241 166.08ZM291.863 289.709L262.786 314.881L292.34 169.724L321.974 281.006L291.863 289.709Z",
    fill: "#D7DFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.03 170.761L272.168 166.24L271.094 171.537L278.955 176.058L280.03 170.761Z",
    fill: "#B3BAD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.409 159.49L252.548 154.989L251.453 160.267L259.314 164.787L260.409 159.49Z",
    fill: "#B3BAD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.772 148.218L232.931 143.718L231.836 149.015L239.697 153.516L240.772 148.218Z",
    fill: "#B3BAD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.139 136.947L213.278 132.446L212.203 137.744L220.044 142.244L221.139 136.947Z",
    fill: "#B3BAD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.518 125.674L193.657 121.174L192.562 126.471L200.424 130.972L201.518 125.674Z",
    fill: "#B3BAD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.881 114.403L174.02 109.902L172.945 115.2L180.807 119.7L181.881 114.403Z",
    fill: "#B3BAD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.253 103.132L154.391 98.6309L153.297 103.928L161.158 108.429L162.253 103.132Z",
    fill: "#B3BAD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.287 149.671C288.137 148.437 285.391 148.636 282.565 150.269C277.311 153.296 273.211 160.405 273.211 166.439C273.211 169.108 274.007 171.239 275.52 172.633C276.535 173.569 277.808 174.067 279.221 174.146L279.898 170.801C279.022 170.88 278.306 170.661 277.749 170.163C276.953 169.446 276.515 168.132 276.515 166.439C276.515 161.66 280.037 155.566 284.217 153.156C285.948 152.161 287.54 151.942 288.595 152.559C289.65 153.156 290.247 154.63 290.247 156.582C290.247 158.792 289.511 161.341 288.177 163.771L291.103 165.384C292.715 162.476 293.591 159.35 293.591 156.582C293.61 153.356 292.416 150.906 290.287 149.671Z",
    fill: "#D7DFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.662 138.4C268.512 137.165 265.766 137.364 262.94 138.997C257.686 142.024 253.586 149.134 253.586 155.168C253.586 157.836 254.382 159.967 255.895 161.361C256.91 162.297 258.183 162.795 259.596 162.875L260.273 159.529C259.397 159.609 258.681 159.39 258.124 158.892C257.328 158.175 256.89 156.861 256.89 155.168C256.89 150.388 260.412 144.295 264.592 141.885C266.323 140.889 267.915 140.67 268.97 141.288C270.025 141.885 270.622 143.359 270.622 145.31C270.622 147.521 269.886 150.07 268.552 152.499L271.478 154.112C273.09 151.205 273.966 148.078 273.966 145.31C273.966 142.084 272.791 139.635 270.662 138.4Z",
    fill: "#D7DFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.021 127.128C248.872 125.894 246.125 126.093 243.299 127.726C238.045 130.753 233.945 137.862 233.945 143.896C233.945 146.565 234.741 148.696 236.254 150.09C237.269 151.026 238.543 151.524 239.956 151.603L240.632 148.258C239.757 148.337 239.04 148.118 238.483 147.62C237.687 146.903 237.249 145.589 237.249 143.896C237.249 139.117 240.772 133.023 244.951 130.613C246.683 129.618 248.275 129.399 249.33 130.016C250.384 130.613 250.981 132.087 250.981 134.039C250.981 136.249 250.245 138.798 248.912 141.228L251.837 142.841C253.449 139.933 254.325 136.807 254.325 134.039C254.345 130.813 253.171 128.363 251.021 127.128Z",
    fill: "#D7DFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.396 115.857C229.247 114.622 226.5 114.821 223.674 116.454C218.42 119.481 214.32 126.591 214.32 132.625C214.32 135.293 215.116 137.424 216.629 138.818C217.644 139.754 218.918 140.252 220.331 140.332L221.007 136.986C220.132 137.066 219.415 136.847 218.858 136.349C218.062 135.632 217.624 134.318 217.624 132.625C217.624 127.845 221.147 121.752 225.326 119.342C227.058 118.346 228.65 118.127 229.705 118.745C230.759 119.342 231.356 120.816 231.356 122.767C231.356 124.978 230.62 127.527 229.287 129.956L232.212 131.569C233.824 128.662 234.7 125.535 234.7 122.767C234.7 119.561 233.526 117.092 231.396 115.857Z",
    fill: "#D7DFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.771 104.585C209.622 103.35 206.875 103.549 204.049 105.182C198.795 108.209 194.695 115.318 194.695 121.352C194.695 124.021 195.491 126.152 197.004 127.546C198.019 128.482 199.293 128.98 200.706 129.059L201.382 125.714C200.507 125.793 199.79 125.574 199.233 125.076C198.437 124.36 197.999 123.045 197.999 121.352C197.999 116.573 201.522 110.479 205.701 108.07C207.433 107.074 209.025 106.855 210.08 107.472C211.134 108.07 211.731 109.543 211.731 111.495C211.731 113.705 210.995 116.254 209.662 118.684L212.587 120.297C214.199 117.389 215.075 114.263 215.075 111.495C215.075 108.289 213.901 105.819 211.771 104.585Z",
    fill: "#D7DFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.131 93.315C189.981 92.0803 187.235 92.2794 184.409 93.9124C179.154 96.9394 175.055 104.049 175.055 110.083C175.055 112.751 175.851 114.882 177.363 116.276C178.378 117.212 179.652 117.71 181.065 117.79L181.742 114.444C180.866 114.524 180.15 114.305 179.592 113.807C178.796 113.09 178.358 111.776 178.358 110.083C178.358 105.303 181.881 99.2097 186.06 96.8C187.792 95.8043 189.384 95.5852 190.439 96.2026C191.494 96.8 192.091 98.2737 192.091 100.225C192.091 102.436 191.354 104.985 190.021 107.414L192.947 109.027C194.559 106.12 195.434 102.993 195.434 100.225C195.454 97.0191 194.28 94.5497 192.131 93.315Z",
    fill: "#D7DFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.506 82.0621C170.356 80.8274 167.61 81.0265 164.784 82.6595C159.529 85.6865 155.43 92.7959 155.43 98.83C155.43 101.499 156.226 103.629 157.738 105.023C158.753 105.959 160.027 106.457 161.44 106.537L162.117 103.191C161.241 103.271 160.525 103.052 159.967 102.554C159.171 101.837 158.733 100.523 158.733 98.83C158.733 94.0506 162.256 87.9567 166.435 85.5471C168.167 84.5514 169.759 84.3323 170.814 84.9497C171.869 85.5471 172.466 87.0208 172.466 88.9724C172.466 91.1829 171.729 93.7319 170.396 96.1615L173.322 97.7746C174.934 94.867 175.809 91.7405 175.809 88.9724C175.809 85.7462 174.635 83.2968 172.506 82.0621Z",
    fill: "#D7DFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.859 123.861C232.859 121.91 232.262 120.436 231.207 119.838C231.147 119.799 231.088 119.779 231.028 119.759C231.526 120.516 231.804 121.611 231.804 122.925C231.804 125.136 231.068 127.685 229.734 130.114L230.928 130.771C232.162 128.422 232.859 125.972 232.859 123.861Z",
    fill: "#B3BAD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.438 137.384L150.582 130.015C149.686 129.498 148.532 130.035 148.353 131.051L147.875 133.72L164.931 143.498L165.309 141.387C165.588 139.793 164.851 138.2 163.438 137.384Z",
    fill: "#72B5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.977 147.421L168.121 140.053C167.225 139.535 166.071 140.072 165.892 141.088L165.414 143.757L182.47 153.535L182.848 151.424C183.147 149.85 182.39 148.237 180.977 147.421Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.501 157.458L185.644 150.09C184.749 149.572 183.594 150.11 183.415 151.125L182.938 153.794L199.993 163.572L200.372 161.461C200.67 159.888 199.914 158.275 198.501 157.458Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.04 167.514L203.183 160.145C202.288 159.628 201.133 160.165 200.954 161.181L200.477 163.849L217.533 173.627L217.911 171.516C218.209 169.923 217.453 168.31 216.04 167.514Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.595 177.551L220.738 170.182C219.842 169.665 218.688 170.202 218.509 171.218L218.031 173.887L235.087 183.665L235.465 181.554C235.744 179.96 234.988 178.367 233.595 177.551Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.118 187.588L238.261 180.22C237.366 179.702 236.211 180.239 236.032 181.255L235.555 183.924L252.611 193.702L252.989 191.591C253.267 190.017 252.531 188.404 251.118 187.588Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.657 197.625L255.8 190.257C254.905 189.739 253.751 190.277 253.571 191.292L253.094 193.961L270.15 203.739L270.528 201.628C270.806 200.055 270.07 198.442 268.657 197.625Z",
    fill: "#E9EEFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.35 288.651C80.2163 288.651 94.6999 282.311 94.6999 274.489C94.6999 266.668 80.2163 260.327 62.35 260.327C44.4836 260.327 30 266.668 30 274.489C30 282.311 44.4836 288.651 62.35 288.651Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4766 269.209H85.3274V272.137H85.311C85.311 272.203 85.3274 272.285 85.3274 272.351C85.3274 281.019 73.2784 288.042 58.402 288.042C43.5256 288.042 31.4766 281.019 31.4766 272.351C31.4766 272.285 31.4766 272.203 31.493 272.137H31.4766V269.209Z",
    fill: "#E8EDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.402 285.016C73.2725 285.016 85.3274 277.991 85.3274 269.324C85.3274 260.658 73.2725 253.633 58.402 253.633C43.5315 253.633 31.4766 260.658 31.4766 269.324C31.4766 277.991 43.5315 285.016 58.402 285.016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M58.402 284.95C73.114 284.95 85.0644 278.075 85.311 269.538C85.311 269.637 85.3274 269.719 85.3274 269.818C85.3274 278.486 73.2784 285.509 58.402 285.509C43.5256 285.509 31.4766 278.486 31.4766 269.818C31.4766 269.719 31.493 269.637 31.493 269.538C31.7396 278.075 43.69 284.95 58.402 284.95Z",
    fill: "#2E79DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4048 282.566C70.9512 282.566 81.1221 276.682 81.1221 269.423C81.1221 262.165 70.9512 256.281 58.4048 256.281C45.8584 256.281 35.6875 262.165 35.6875 269.423C35.6875 276.682 45.8584 282.566 58.4048 282.566Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4048 265.476C48.6571 265.476 40.3723 269.028 37.1505 274.012C36.23 272.581 35.6875 271.035 35.6875 269.407C35.6875 262.153 45.8626 256.265 58.4048 256.265C70.947 256.265 81.1221 262.153 81.1221 269.407C81.1221 271.019 80.5961 272.565 79.6591 274.012C76.4373 269.028 68.1525 265.476 58.4048 265.476Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.85 268.502V265.146C34.85 253.452 41.2937 242.711 51.6168 237.201L54.0003 235.934C55.0523 235.375 55.0852 233.878 54.0825 233.27L50.088 230.852C40.6362 225.111 34.8665 214.847 34.8665 203.778V194.172H81.9613V203.531C81.9613 214.732 76.0436 225.111 66.3945 230.802L62.3508 233.187C61.3152 233.796 61.3481 235.309 62.4165 235.868L64.8658 237.135C75.3532 242.579 81.9448 253.419 81.9448 265.245V268.321C82.3065 272.087 80.0216 275.92 75.0409 278.798C65.7863 284.144 50.8277 284.177 41.6389 278.864C36.7404 276.019 34.4884 272.236 34.85 268.502Z",
    fill: "url(#paint3_linear_2_156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7993 220.785C44.1828 224.239 47.3225 226.937 51.0704 229.207L55.0648 231.625C56.1168 232.266 56.7579 233.434 56.725 234.668C56.7086 235.473 56.0017 242.415 55.525 247.135C55.2292 250.03 53.3059 252.53 50.5772 253.501C42.8514 256.231 36.7857 255.853 36.7857 265.13V268.567L36.7693 268.666C36.4734 271.758 38.6104 274.867 42.6212 277.186C46.7636 279.571 52.3196 280.904 58.2702 280.904C64.2865 280.904 69.9083 279.571 74.1164 277.137C78.2095 274.768 80.3793 271.627 80.0834 268.502L80.067 268.403V265.245C80.067 255.837 73.8698 256.165 65.9796 253.419C63.2345 252.465 61.2948 249.981 60.9825 247.086C60.4729 242.365 59.7332 235.424 59.7003 234.602C59.6674 233.352 60.3085 232.184 61.3934 231.542L65.4372 229.157C68.8891 227.118 71.848 224.766 74.1822 221.739L41.7993 220.785Z",
    fill: "#F3C042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2561 227.759C67.8339 227.759 75.5982 223.237 75.5982 217.66C75.5982 212.082 67.8339 207.561 58.2561 207.561C48.6784 207.561 40.9141 212.082 40.9141 217.66C40.9141 223.237 48.6784 227.759 58.2561 227.759Z",
    fill: "#FDC94C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4766 192.593H85.3274V195.521H85.311C85.311 195.586 85.3274 195.669 85.3274 195.734C85.3274 204.403 73.2784 211.426 58.402 211.426C43.5256 211.426 31.4766 204.403 31.4766 195.734C31.4766 195.669 31.4766 195.586 31.493 195.521H31.4766V192.593Z",
    fill: "#E8EDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3274 192.692C84.3274 196.521 81.6567 200.173 76.9376 202.923C72.2433 205.659 65.6922 207.383 58.402 207.383C51.1118 207.383 44.5607 205.659 39.8664 202.923C35.1473 200.173 32.4766 196.521 32.4766 192.692C32.4766 188.862 35.1473 185.21 39.8663 182.46C44.5607 179.724 51.1118 178 58.402 178C65.6922 178 72.2433 179.724 76.9376 182.46C81.6567 185.21 84.3274 188.862 84.3274 192.692Z",
    fill: "white",
    stroke: "#E9EEFB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M58.402 208.334C73.114 208.334 85.0644 201.458 85.311 192.922C85.311 193.021 85.3274 193.103 85.3274 193.201C85.3274 201.87 73.2784 208.893 58.402 208.893C43.5256 208.893 31.4766 201.87 31.4766 193.201C31.4766 193.103 31.493 193.021 31.493 192.922C31.7396 201.458 43.69 208.334 58.402 208.334Z",
    fill: "#2E79DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7734 254.258C60.7734 254.258 73.6444 259.061 75.7813 263.337C77.9183 267.63 76.1594 270.525 72.0006 270.788C67.8418 271.052 70.8664 263.732 60.7734 254.258Z",
    fill: "#FDC94C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.883 72.0251L87.1234 44.3834C78.7749 39.5578 72 44.675 72 55.8133V111.126C72 122.264 78.7749 135.21 87.1234 140.036L134.883 167.677C143.232 172.503 150.007 167.386 150.007 156.248V100.935C150.007 89.7822 143.232 76.8507 134.883 72.0251Z",
    fill: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.682 67.4473L94.9225 39.8056C91.3529 37.7354 88.0601 37.5168 85.4813 38.7851L85.3939 38.6976L77.1328 43.5524L77.1619 43.6545C79.8282 42.0654 83.3104 42.1674 87.1277 44.3834L134.887 72.0251C143.236 76.8507 150.011 89.7822 150.011 100.935V156.247C150.011 161.656 148.408 165.636 145.8 167.75L150.404 164.718C154.28 162.502 157.791 159.047 157.791 151.67V96.3573C157.791 85.219 151.031 72.2729 142.682 67.4473Z",
    fill: "#D7DFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.007 100.935C150.007 89.7968 143.232 76.8507 134.883 72.0251L87.1234 44.3834C78.7749 39.5578 72 44.675 72 55.8133L150.007 100.935Z",
    fill: "url(#paint4_linear_2_156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.791 96.3573C157.791 85.219 151.016 72.2729 142.668 67.4473L94.9225 39.8056C91.3529 37.7354 88.0601 37.5168 85.4813 38.7851L85.3939 38.6976L77.1328 43.5524L77.1619 43.6545C79.8282 42.0654 83.3104 42.1674 87.1277 44.3834L134.887 72.0251C143.236 76.8507 150.011 89.7822 150.011 100.935L157.791 96.3573Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.791 96.3573C157.791 85.219 151.016 72.2729 142.668 67.4473L94.9225 39.8056C91.3529 37.7354 88.0601 37.5168 85.4813 38.7851L85.3939 38.6976L77.1328 43.5524L77.1619 43.6545C79.8282 42.0654 83.3104 42.1674 87.1277 44.3834L134.887 72.0251C143.236 76.8507 150.011 89.7822 150.011 100.935L157.791 96.3573Z",
    fill: "url(#paint5_linear_2_156)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M135.724 71.31L87.9641 43.6683C83.8117 41.2774 80.0672 41.3357 77.3281 43.3622C79.805 42.4145 82.8355 42.7644 86.1283 44.6597L133.888 72.3013C142.236 77.127 149.011 90.0731 149.011 101.211V156.524C149.011 162.137 147.292 166.204 144.524 168.26C148.341 166.802 150.847 162.282 150.847 155.532V100.22C150.847 89.0817 144.072 76.1356 135.724 71.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4989 119.013C85.4989 115.237 86.0235 112.307 87.0725 110.222C88.1215 108.137 90.0156 106.242 92.7401 104.536C95.421 102.802 97.2713 101.081 98.3058 99.361C99.3402 97.6406 99.8502 95.5267 99.8502 93.0045C99.8502 90.7302 99.5296 88.9808 98.8886 87.727C98.2475 86.4732 97.315 85.4964 96.0912 84.782C93.5852 83.3387 92.3467 84.3592 92.3467 87.829V93.5002L85.4989 89.5493V84.4176C85.4989 80.1314 86.4168 77.3759 88.2672 76.1513C90.103 74.9267 92.7838 75.3203 96.2952 77.3468C99.8065 79.3732 102.487 82.0703 104.323 85.4235C106.159 88.7767 107.091 92.5963 107.091 96.8825C107.091 100.104 106.421 102.874 105.081 105.163C103.74 107.467 101.424 109.654 98.1309 111.738C95.9746 113.123 94.5322 114.406 93.7891 115.616C93.0461 116.827 92.6673 118.357 92.6673 120.223V121.361L106.421 129.306V136.858L85.4844 124.772V119.013H85.4989Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.526 138.84C112.69 135.487 111.758 131.668 111.758 127.381V123.226L118.606 127.177V131.93C118.606 135.356 119.859 137.791 122.35 139.234C124.856 140.677 126.094 139.686 126.094 136.26V124.393C126.094 120.923 124.841 118.459 122.35 117.016C119.844 115.573 118.606 116.593 118.606 120.063V120.515L111.758 116.564L113.069 87.7705L132.155 98.7922V106.344L119.524 99.04L118.926 111.315L119.057 111.388C120.412 109.61 122.496 109.522 125.308 111.141C127.945 112.657 129.941 114.844 131.296 117.701C132.651 120.559 133.336 123.941 133.336 127.877V139.817C133.336 144.103 132.418 146.859 130.567 148.084C128.732 149.308 126.051 148.915 122.539 146.888C119.043 144.891 116.362 142.208 114.526 138.84Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.886 138.389C126.79 138.083 127.241 136.931 127.241 134.875V123.008C127.241 119.538 125.988 117.074 123.497 115.631C121.632 114.552 120.466 114.844 120 116.491C120.597 116.287 121.384 116.462 122.375 117.031C124.881 118.474 126.119 120.938 126.119 124.408V136.275C126.119 137.135 126.046 137.835 125.886 138.389Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.658 97.6699L120.57 99.6672L132.182 106.374V104.318L120.658 97.6699Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.613 120.077C118.613 119.494 118.657 118.999 118.73 118.547L112.888 115.164L114.111 88.3829L113.077 87.7852L111.766 116.579L118.613 120.529V120.077Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.712 146.713C129.876 147.938 127.195 147.544 123.684 145.518C120.172 143.491 117.492 140.794 115.656 137.441C113.82 134.088 112.888 130.268 112.888 125.982V123.883L111.766 123.227V127.382C111.766 131.668 112.684 135.487 114.534 138.841C116.37 142.194 119.051 144.891 122.562 146.917C126.073 148.944 128.754 149.352 130.59 148.113C131.202 147.705 131.697 147.121 132.09 146.392C131.974 146.509 131.857 146.626 131.712 146.713Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3556 91.6344L87.7516 88.9811V83.8493C87.7516 79.5631 88.6695 76.8077 90.5198 75.583C90.5927 75.5393 90.6801 75.4956 90.7675 75.4518C89.8205 75.4372 88.99 75.6705 88.2761 76.137C86.4403 77.3617 85.5078 80.1171 85.5078 84.4033V89.5351L92.3556 93.4859V91.6344V91.6344Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7516 124.204V118.46C87.7516 114.684 88.2761 111.754 89.3251 109.669C90.3741 107.584 92.2682 105.689 94.9927 103.983C97.6736 102.248 99.5239 100.528 100.558 98.8077C101.593 97.0874 102.103 94.9734 102.103 92.4513C102.103 90.177 101.782 88.4275 101.141 87.1737C100.5 85.9199 99.5676 84.9431 98.3438 84.2288C96.814 83.3395 95.7504 83.3978 95.1676 84.3454C95.459 84.4475 95.7649 84.5933 96.1 84.7828C97.3239 85.4971 98.2564 86.4739 98.8974 87.7277C99.5385 88.9815 99.859 90.731 99.859 93.0053C99.859 95.5274 99.3491 97.6414 98.3146 99.3617C97.2802 101.082 95.4298 102.802 92.749 104.537C90.0244 106.243 88.1449 108.138 87.0813 110.223C86.0323 112.308 85.5078 115.238 85.5078 119.029V124.773L106.445 136.859V134.993L87.7516 124.204Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.572 66.6897C103.559 65.5275 103.54 61.796 101.53 58.3553C99.5196 54.9145 96.2794 53.0674 94.2926 54.2296C92.3059 55.3918 92.325 59.1233 94.3352 62.564C96.3455 66.0048 99.5857 67.8519 101.572 66.6897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.091 72.5355C125.264 70.9027 122.977 72.2148 122.977 75.4513C122.977 78.6878 125.264 82.6533 128.091 84.2861C130.917 85.9189 133.205 84.6068 133.205 81.3703C133.205 78.1192 130.917 74.1683 128.091 72.5355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.145 64.095C99.3184 62.4621 97.031 58.5112 97.031 55.2601C97.031 54.8811 97.0747 54.5458 97.133 54.2104C94.6852 53.2482 92.8203 54.5749 92.8203 57.5053C92.8203 60.7564 95.1078 64.7073 97.9343 66.3401C100.44 67.7834 102.509 66.9233 102.961 64.4594C102.684 64.3574 102.422 64.2553 102.145 64.095Z",
    fill: "url(#paint6_linear_2_156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.301 82.0412C129.475 80.4084 127.187 76.4575 127.187 73.2064C127.187 72.8274 127.231 72.4921 127.289 72.1567C124.841 71.1945 122.977 72.5212 122.977 75.4516C122.977 78.7027 125.264 82.6536 128.091 84.2864C130.597 85.7297 132.665 84.8696 133.117 82.4057C132.84 82.3037 132.578 82.2016 132.301 82.0412Z",
    fill: "url(#paint7_linear_2_156)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_156",
    x1: 224.539,
    y1: 218.814,
    x2: 249.305,
    y2: 232.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA3C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_156",
    x1: 144.698,
    y1: 158.383,
    x2: 199.923,
    y2: 158.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ED3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ED3F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_156",
    x1: 217.559,
    y1: 269.714,
    x2: 255.771,
    y2: 269.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ED3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ED3F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_156",
    x1: 34.8125,
    y1: 194.172,
    x2: 99.9142,
    y2: 217.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA3C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_156",
    x1: 72,
    y1: 42.5664,
    x2: 138.578,
    y2: 103.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA3C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_156",
    x1: 77.1328,
    y1: 38,
    x2: 148.578,
    y2: 100.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA3C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_156",
    x1: 92.8203,
    y1: 53.9004,
    x2: 105.225,
    y2: 60.4247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA3C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_156",
    x1: 122.977,
    y1: 71.8467,
    x2: 135.381,
    y2: 78.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FA3C0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 353,
    height: 317,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramImg);
export default __webpack_public_path__ + "static/media/programImg.edc0bc2a.svg";
export { ForwardRef as ReactComponent };